import React from 'react';
import type { RouteObject } from 'react-router-dom';
import MyPay from './MyPay';

export const myPayRoutes: RouteObject[] = [
  { path: 'my-pay', element: <MyPay /> },
];
